import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import KinergoSection from "./components/KinergoSection";
import BrandsSection from "./components/BrandsSection";
import ServicesSection from "./components/ServicesSection";
import AboutSection from "./components/AboutSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import InstagramFeedSection from "@/components/feature/InstagramFeedSection";
import SeoHead from "@/seo/SeoHead";
import { buildAutoRepairJsonLd, buildWebSiteJsonLd } from "@/seo/jsonLd";
import { useSiteContent } from "@/cms/SiteContentContext";

export default function Home() {
  const { content } = useSiteContent();
  const hero = content.home.hero;

  const seoDescription = `${hero.description} Car Garage VAG (cargaragevag) — Pendik, İstanbul.`;
  const jsonLd = [buildWebSiteJsonLd(), buildAutoRepairJsonLd()];

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#09090b" }}>
      <SeoHead
        title="Volkswagen Grubu Özel Servis Pendik"
        description={seoDescription}
        path="/"
        image="/images/card.png"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <KinergoSection />
        <BrandsSection />
        <ServicesSection />
        <AboutSection />
        <TestimonialsSection />
        <InstagramFeedSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
